import React from "react";
import { ArrowBackCircle, ArrowForwardCircle, ArrowDownCircle, Calendar } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/Post"
import SearchFilterFunction from "../Functions/SearchFilter"
import stylesMed from "./stylesMed"
import Authenticate from "../Functions/MedRepAuthenticate"

function convertNumToTime(number) {
    var sign = (number >= 0) ? 1 : -1;
    number = number * sign;
    var hour = Math.floor(number);
    var decpart = number - hour;
    var min = 1 / 60;
    decpart = min * Math.round(decpart / min);
    var minute = Math.floor(decpart * 60) + '';
    if (minute.length < 2) {
        minute = '0' + minute;
    }
    sign = sign == 1 ? '' : '-';
    var time = sign + hour + ':' + minute;
    return time;
}

export default class DailySchedule extends React.Component {

    constructor() {
        super();
        this.state = {
            dailySchedule: [],
            visits: [],
            visitsCopy: [],
            activities: [],
            activitiesCopy: [],
            noData: true,
            show: [true, false],
            Date: new Date().toISOString().substring(0, 10),
            loading: true,
            user: "",
            token: "",
            currentRep: 0,
            coaching: [],
            coachingCopy: [],
            reps: [],
            coachDay: false,
            coachingRequests: [],
            coachingRequestsCopy: [],
            showRequests: false,
            todaysDate: new Date().toISOString().substring(0, 10),
            authenticate: false,
            alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const user = localStorage.getItem('User');
        const token = localStorage.getItem('Token');
        var isSupervisor = localStorage.getItem("isSupervisor");
        await this.setState({ user: JSON.parse(user), token: JSON.parse(token), isSupervisor: JSON.parse(isSupervisor) });

        const readURL = constantURI() + "odooController/MedRepRead";
        const currentRepBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.users",
                "args": [],
                "kwargs": {
                    "fields": ["name", "supervisor"],
                    "domain": [["name", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(readURL, currentRepBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ currentRep: data.result[0].id });
                        localStorage.setItem('CurrentUserId', JSON.stringify(this.state.skills));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const currentRep = localStorage.getItem("CurrentUrserId");
            this.setState({ currentRep: JSON.parse(currentRep) });
        }
        const coachingBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "coaching",
                args: [],
                kwargs: {
                    fields: ["date"],
                    domain: [["supervisor_id", "=", this.state.currentRep], ["status", "=", "approved"], ["date", "=", this.state.Date]]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(readURL, coachingBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ coaching: data.result, coachingCopy: data.result });
                        localStorage.setItem('Coaching', JSON.stringify(this.state.coaching));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const coaching = localStorage.getItem("Coaching");
            this.setState({ coaching: JSON.parse(coaching), coachingCopy: JSON.parse(coaching) });
        }

        const coachingRequestBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "coaching",
                args: [],
                kwargs: {
                    fields: ["date", "status"],
                    domain: [["supervisor_id", "=", this.state.currentRep], ["status", "=", "requested"], ["date", "=", this.state.Date]]
                }
            },
            "token": this.state.token
        }
        console.log(JSON.stringify(coachingRequestBody));
        if (this.state.authenticate) {
            await _post(readURL, coachingRequestBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ coachingRequests: data.result, coachingRequestsCopy: data.result });
                        localStorage.setItem('CoachingRequests', JSON.stringify(this.state.coachingRequests));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const coaching = localStorage.getItem("CoachingRequests");
            this.setState({ coachingRequests: JSON.parse(coaching), coachingRequestsCopy: JSON.parse(coaching) });
        }

        await this.state.coachingRequests.forEach((item, index) => {
            if (item.date === this.state.Date) {
                this.setState({ coachDay: true });
            }
        })

        if ((!this.state.isSupervisor && !this.state.coachDay) || this.state.isSupervisor) {
            await this.setState({ dailySchedule: [{ name: "Visits" }, { name: "Activities" }] })
        }
        else if (!this.state.isSupervisor && this.state.coachDay) {
            await this.setState({ dailySchedule: [{ name: "Coaching" }, { name: "Activities" }] })
        }

        this.state.dailySchedule.map(async (item, index, arr) => {
            if (this.state.isSupervisor) {
                const visitsBody = {
                    jsonrpc: "2.0",
                    params: {
                        method: "search_read",
                        model: "calendar.event",
                        args: [],
                        kwargs: {
                            fields: ["name", "x_status", "start_datetime", "partner_ids", "x_fbgeneral", "supdatein", "x_specialrequest_to_delivery"],
                            domain: [["partner_ids", "=", this.state.user], ["x_status", "=", index], ["start_date", "=", this.state.Date]]
                        }
                    },
                    "token": this.state.token
                }
                if (this.state.authenticate) {
                    await _post(readURL, visitsBody).then((response) => {
                        return response.json().then(async (data) => {
                            if (data.result !== undefined) {
                                await this.setState({ visits: [...this.state.visits, ...data.result], visitsCopy: [...this.state.visitsCopy, ...data.result] });
                                localStorage.setItem('Visits', JSON.stringify(this.state.visits));
                                if (index === 1) {
                                    this.setState({ loading: false });
                                }
                            }
                            else {
                                this.setState({ alertUndefined: true });
                            }
                        })
                    })
                }
                else {
                    const visits = localStorage.getItem('Visits');
                    this.setState({ visits: JSON.parse(visits), visitsCopy: JSON.parse(visits) });
                }
            }
            else {
                const reps = JSON.parse(localStorage.getItem("Reps"));
                await this.setState({ reps: reps });
                this.state.reps.map(async (item2) => {
                    const visitsBody = {
                        jsonrpc: "2.0",
                        params: {
                            method: "search_read",
                            model: "calendar.event",
                            args: [],
                            kwargs: {
                                fields: ["name", "x_status", "start_datetime", "partner_ids", "x_fbgeneral", "supdatein", "x_specialrequest_to_delivery"],
                                domain: [["partner_ids", "=", item2.name], ["x_status", "=", index], ["start_date", "=", this.state.Date]]
                            }
                        },
                        "token": this.state.token
                    }
                    if (this.state.authenticate) {
                        await _post(readURL, visitsBody).then((response) => {
                            return response.json().then(async (data) => {
                                if (data.result !== undefined) {
                                    await this.setState({ visits: [...this.state.visits, ...data.result], visitsCopy: [...this.state.visitsCopy, ...data.result] });
                                    localStorage.setItem('Visits', JSON.stringify(this.state.visits));
                                    if (index === 1) {
                                        this.setState({ loading: false });
                                    }
                                }
                                else {
                                    this.setState({ alertUndefined: true });
                                }
                            })
                        })
                    }
                    else {
                        const visits = localStorage.getItem('Visits');
                        this.setState({ visits: JSON.parse(visits), visitsCopy: JSON.parse(visits) });
                    }
                })
            }
            const ActivityBody = {
                jsonrpc: "2.0",
                params: {
                    method: "search_read",
                    model: "event.event",
                    args: [],
                    kwargs: {
                        "fields": ["name", "date_begin", "x_status"],
                        "domain": [["x_repuserid", "=", this.state.user], ["date_begin", "=", this.state.Date], ["x_status", "=", index]]
                    }
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(readURL, ActivityBody).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await this.setState({ activities: [...this.state.activities, ...data.result], activitiesCopy: [...this.state.activitiesCopy, ...data.result] });
                            localStorage.setItem('Activities', JSON.stringify(this.state.activities));
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                const clients = localStorage.getItem('Activities');
                this.setState({ activities: JSON.parse(clients), activitiesCopy: JSON.parse(clients), loading: false });
            }
        })
        const clientsURL = constantURI() + "odooController/MedRepRead";
        const RepsBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "medrepsettings",
                "args": [],
                "kwargs": {
                    "fields": ["in_time", "out_time", "out_of_rout_visit"],
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(clientsURL, RepsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ limits: data.result });
                        localStorage.setItem('Limits', JSON.stringify(this.state.limits));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const limits = localStorage.getItem('Limits');
            await this.setState({ limits: JSON.parse(limits) });
        }
    }

    onSearchVisits = async (text) => {
        var values = await SearchFilterFunction(text, this.state.visits, this.state.visitsCopy, this.state.noData);
        this.setState({ visits: values.items, noData: values.noData })
    }

    onSearchActivities = async (text) => {
        var values = await SearchFilterFunction(text, this.state.activities, this.state.activitiesCopy, this.state.noData);
        this.setState({ activities: values.items, noData: values.noData })
    }

    onSearchRequests = async (text) => {
        var values = await SearchFilterFunction(text, this.state.coachingRequests, this.state.coachingRequestsCopy, this.state.noData);
        this.setState({ coachingRequests: values.items, noData: values.noData })
    }

    onShow = (index) => {
        this.setState({ ...this.state.show[index] = !this.state.show[index] });
    }

    onShowRequests = () => {
        this.setState({ ...this.state.showRequests = !this.state.showRequests });
    }

    onVisitClick = async (visit, request, status) => {
        if (new Date().getTime() >= new Date(this.state.todaysDate + " " + convertNumToTime(this.state.limits[0].in_time)).getTime() && new Date().getTime() <= new Date(this.state.todaysDate + " " + convertNumToTime(this.state.limits[0].out_time)).getTime()) {
            if (visit.x_status === "0" && this.state.isSupervisor) {
                await localStorage.setItem('HCPDailySched', JSON.stringify(visit.partner_ids[0]));
                await localStorage.setItem('VisitID', JSON.stringify(visit.id));
                await localStorage.setItem('Request', JSON.stringify(request));
                this.props.history.push("/AddVisit");
            }
            if (!this.state.isSupervisor && this.state.coachDay && !status) {
                await localStorage.setItem('HCPDailySched', JSON.stringify(visit.partner_ids[0]));
                await localStorage.setItem('VisitID', JSON.stringify(visit.id));
                await localStorage.setItem('Request', JSON.stringify(request));
                await localStorage.setItem('CoachDay', JSON.stringify(this.state.coachDay));
                this.props.history.push("/AddVisit");
            }
        }
        else {
            alert("You are allowed to create visits during these times: between " + convertNumToTime(this.state.limits[0].in_time) + " and " + convertNumToTime(this.state.limits[0].out_time));
        }
    }

    onActivityClick = async (activity) => {
        if (activity.x_status === "0") {
            await localStorage.setItem('ActivityID', JSON.stringify(activity.id));
            this.props.history.push("/AddActivity");
        }
    }

    render() {
        if (!this.state.loading && this.state.visits.length >= 0) {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainBackgroundColor}>
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageRep")} color={'#00bfff'} height="50px" width="50px" />
                        </div>
                        <div className="col d-flex align-items-center justify-content-center">
                            <div className="d-flex align-items-center justify-content-center">
                                <Calendar className="btn" onClick={() => this.props.history.push("./LandingPageRep")} color={'#00bfff'} height="35px" width="35px" />
                            </div>
                            <div className="d-flex align-items-center"><h5 style={stylesMed.dailyDate}>{new Date(this.state.Date).toDateString()}</h5></div>
                        </div>
                        <div className="col"></div>
                    </div>
                    <div style={stylesMed.dailyTabs}>
                        {this.state.dailySchedule.map((item, index) => {
                            return (
                                <div className="pt-3" style={stylesMed.mainBackgroundColor} key={index}>
                                    <div className="btn bg-light" style={stylesMed.dailyCard} onClick={() => this.onShow(index)}>
                                        <div className="row">
                                            {(this.state.show[index]) ?
                                                <ArrowDownCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                                :
                                                <ArrowForwardCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                            }
                                            <h5 className="col pt-2 d-flex justify-content-start">{item.name}</h5>
                                        </div>
                                    </div>
                                    {(index === 0) ?
                                        (this.state.show[index]) ?
                                            <div>
                                                <div className="m-2">
                                                    <input type="text" className="form-control" placeholder="Search Here" onInput={(text) => this.onSearchVisits(text)} />
                                                </div>
                                                {this.state.visits.map((visit, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <div className="row m-2"
                                                                style={(!this.state.isSupervisor && visit.supdatein) ? stylesMed.dailyCoached : (visit.x_status === "0") ? stylesMed.dailyPending : stylesMed.dailyCompleted}
                                                                onClick={() => this.onVisitClick(visit, visit.x_specialrequest_to_delivery, visit.supdatein)}>
                                                                <div className="row mt-1">
                                                                    <p className="col" style={stylesMed.dailyNumber}>Visit #{index + 1}</p>
                                                                    <p className="col d-flex flex-row-reverse">{visit.start_datetime}</p>
                                                                </div>
                                                                <p style={stylesMed.dailyMargin}>Last Visit: { }</p>
                                                                <p style={stylesMed.dailyMargin}>{visit.name}</p>
                                                                <p style={stylesMed.dailyMargin}>Special Request to Deliver: {visit.x_specialrequest_to_delivery}</p>
                                                                <p>{(visit.x_status === "0") ? "Pending" : "Completed"}</p>
                                                                <p>{(!this.state.isSupervisor && visit.supdatein) ? "Coached" : null}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div> : null :
                                        (this.state.show[index]) ?
                                            <div>
                                                <div className="m-2">
                                                    <input type="text" className="form-control" placeholder="Search Here" onChange={(text) => this.onSearchActivities(text)} />
                                                </div>
                                                {this.state.activities.map((activity, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <div className="row m-2"
                                                                style={(activity.x_status === "0") ? stylesMed.dailyPending : stylesMed.dailyCompleted}
                                                                onClick={() => this.onActivityClick(activity)}>
                                                                <div className="row mt-1">
                                                                    <p className="col" style={stylesMed.dailyNumber}>Activity #{index + 1}</p>
                                                                    <p className="col d-flex flex-row-reverse">{(activity.date_begin).substring(0, 10)}</p>
                                                                </div>
                                                                <p style={stylesMed.dailyMargin}>{activity.name}</p>
                                                                <p>{(activity.x_status === "0") ? "Pending" : "Completed"}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div> : null
                                    }
                                </div>
                            )
                        })}
                    </div>
                    {(this.state.isSupervisor) ? null :
                        <div className="mt-4">
                            <div className="btn bg-light" style={stylesMed.dailyCard} onClick={() => this.onShowRequests()}>
                                <div className="row">
                                    {(this.state.showRequests) ?
                                        <ArrowDownCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                        :
                                        <ArrowForwardCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                    }
                                    <h5 className="col pt-2 d-flex justify-content-start">Coaching Requests</h5>
                                </div>
                            </div>
                            {(this.state.showRequests) ?
                                <div>
                                    <div className="m-2">
                                        <input type="text" className="form-control" placeholder="Search Here" onChange={(text) => this.onSearchRequests(text)} />
                                    </div>
                                    {this.state.coachingRequests.map((request, index) => {
                                        return (
                                            <div key={index}>
                                                <div className="row m-2"
                                                    style={(request.status === "requested") ? stylesMed.dailyPending : stylesMed.dailyCompleted}>
                                                    <div className="row mt-1">
                                                        <p className="col" style={stylesMed.dailyNumber}>Request #{index + 1}: {request.date}</p>
                                                    </div>
                                                    <p>{(request.status === "requested") ? "Pending" : "Approved"}</p>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div> : null
                            }
                        </div>
                    }
                </div >
            );
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainBackgroundColor}>
                    <div className="pt-3">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageRep")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}

